import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import form from "./src/form.vue";
import formItem from "./src/form-item.vue";
export const xForm = withInstall(form, { formItem });
export default xForm;
export const xFormItem = withNoopInstall(formItem);
